import { render, staticRenderFns } from "./AdvInfos.vue?vue&type=template&id=c70a387e&scoped=true&"
import script from "./AdvInfos.vue?vue&type=script&lang=js&"
export * from "./AdvInfos.vue?vue&type=script&lang=js&"
import style0 from "./AdvInfos.vue?vue&type=style&index=0&id=c70a387e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70a387e",
  null
  
)

export default component.exports